"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NThresholdSystemVolume_1 = require("./NThresholdSystemVolume");
/**
 * @author Tomas Leity
 */


var NThresholdSystemVolumeDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NThresholdSystemVolumeDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NThresholdSystemVolumeDTO(products) {
    var _this;

    _classCallCheck(this, NThresholdSystemVolumeDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NThresholdSystemVolumeDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NThresholdSystemVolumeDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NThresholdSystemVolumeDTO(mat.products);
    }
  }]);

  return NThresholdSystemVolumeDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NThresholdSystemVolumeDTO = NThresholdSystemVolumeDTO;

NThresholdSystemVolumeDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NThresholdSystemVolumeDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NThresholdSystemVolume_1.NThresholdSystemVolume.schema, function (mat) {
      return NThresholdSystemVolume_1.NThresholdSystemVolume.fromDataDict(mat);
    }))
  };
}();